import React from 'react'
import Footer from '../Footer'
import Uml1 from '../Uml1'

function Umass1() {
    window.scrollTo(0,0);
    return (
        <div>
            <Uml1/>
            <Footer/>
        </div>
    )
}

export default Umass1
